import { Filter } from '@anytag/shared-molecules';
import { useTrendingPostsFilter } from './hooks';
import { Template, TemplateProps } from './Template';

export type TrendingPostsFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const TrendingPostsFilter = (props: TrendingPostsFilterProps) => {
  const { filter, setFilterForm } = useTrendingPostsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template {...props} />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
export { useTrendingPostsFilter };
